import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";

import { Memoize } from "@repo/helpers";

import TextAreaMarkup from "./markup";
import { Props } from "./types";

export function TextArea(props: Props) {
	const cursor = useRef<number>();
	const inputEl = useRef<HTMLTextAreaElement>();

	const [value, setValue] = useState(props.value);

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);

	useEffect(() => {
		if (cursor.current) {
			inputEl.current.selectionStart = cursor.current;
			inputEl.current.selectionEnd = cursor.current;
		}
	}, [value]);

	const updateRef = useCallback((element: HTMLTextAreaElement) => {
		inputEl.current = element;
	}, []);

	const updateValue = useCallback(
		function (value: any) {
			setValue(value);
			props.changeHandler(value, props.id);
		},
		[setValue, props.changeHandler, props.id],
	);

	/**
	 * On change handler. Calls valid function if provided and then calls the change
	 * handler
	 * @param event
	 */
	const onChange = useCallback(
		(event: ChangeEvent<HTMLTextAreaElement>) => {
			const element = event.target;
			updateRef(element);
			updateCursor(element);
			updateValue(element.value);
		},
		[updateRef, updateValue],
	);

	const onChangeValue = useCallback(
		(value: any) => {
			if (value !== props.value) updateValue(value);
			//We want the masking thing to handle it's own cursor position
			//updateCursor(_inputEl.current);
		},
		[updateValue],
	);

	function updateCursor(element: HTMLTextAreaElement) {
		cursor.current = element.selectionStart;
	}

	return (
		<TextAreaMarkup
			{...props}
			onChange={onChange}
			inputRef={inputEl}
			onChangeValue={onChangeValue}
			value={value}
			setRef={updateRef}
		/>
	);
}

export default Memoize(TextArea);
